var React = require('react');

function HeroVectorLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#484848","strokeWidth":"2","d":"M-47-734a390 390 0 0 1 550 0L228-459-47-734ZM618 324c0 215-174 389-389 390V323h-1a390 390 0 0 1-1-780v391h1c215 0 390 175 390 390Z"}));
}

HeroVectorLeftInline.defaultProps = {"width":"619","height":"715","fill":"none"};

module.exports = HeroVectorLeftInline;

HeroVectorLeftInline.default = HeroVectorLeftInline;
